import { z } from 'zod';
import { Paginated } from './common/pagination.js';
import { StorageObjectKey } from './storage.js';
export const ProfilePhotoView = z.object({
    id: z.string(),
    url: z.string().url(),
    source: z.enum(['upload', 'post']),
    postId: z.string().optional(),
    caption: z.string(),
    createdAt: z.coerce.date(),
    canDelete: z.boolean(),
    canSetAvatar: z.boolean(),
});
export const ProfilePhotoPage = Paginated(ProfilePhotoView);
export const AddProfilePhotoInput = z.object({
    key: StorageObjectKey,
    caption: z.string().trim().max(1000).default(''),
});
//# sourceMappingURL=profile-photos.js.map